// apiSetup/apiConfig.ts
export const getApiBaseUrl = (): string => {
  // Change this for your real production URL
  if (process.env.NODE_ENV === 'production') {

    return 'https://beta-pitchout-api.skoolpillar.cloud/api';

  }

  // Local development
  return 'https://pitchout-api.skoolpillar.cloud/api';


};